export const SignInHeader = () => {
  return (
    <div className="sign-in-header">
      <h2 className="sign-in-header__title">Login</h2>
    </div>
  );
};
